module.exports = __webpack_public_path__ + "img/table-resident-icon.6d54c7ee.svg";